export const NotificationServiceSymbol = Symbol.for('NotificationService')
